export enum UploadHistoryBehaviorType {
  Override = 'Override',
  Add = 'Add'
}

export enum UploadHistoryAmountType {
  Single = 'Single',
  Multiple = 'Multiple'
}
